function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningred(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.84599 10.6254H7.85124M7.84599 5.37517V8.65656M14.4088 8.00028C14.4088 4.37566 11.4706 1.4375 7.84599 1.4375C4.22136 1.4375 1.2832 4.37566 1.2832 8.00028C1.2832 11.6249 4.22136 14.5631 7.84599 14.5631C11.4706 14.5631 14.4088 11.6249 14.4088 8.00028Z",
    stroke: "#E30000",
    style: {
      stroke: "#E30000",
      stroke: "color(display-p3 0.8902 0.0000 0.0000)",
      strokeOpacity: 1
    },
    strokeWidth: 1.05,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningred);
export default __webpack_public_path__ + "static/media/warningred.0645dbdc9e67847003b581cca250640a.svg";
export { ForwardRef as ReactComponent };